module.exports = __webpack_public_path__ + "static/media/bg2.b6934c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/bg2.png
// module id = 1165
// module chunks = 0